<div *ngIf="this.productType=='G'">
    <div class="userinfo full">
        <div class="basicrow">
            <div class="basicrow f-bmed roboto-b m-bott text-center msj">
                Este servicio solo está habilitado para cuentas fijas.
            </div>
        </div>
    </div>
</div>
<div *ngIf="this.ticketExists=='' && this.ticketOpened=='Y'">
    <div class="userinfo full1">
        <div class="basicrow">
            <div class="basicrow roboto-b text-center var1">
                Boleto Abierto: nos encontramos trabajando con la interrupción de su servicio, podemos ofrecerle un servicio inalámbrico alternativo mientras trabajamos con esta situación.  Puedes buscarlo libre de costo en cualquiera de nuestras localidades abiertas, ingresa a <a href="https://www.claropr.com" target="_blank" rel="noopener noreferrer">www.claropr.com</a>
            </div>
        </div>
    </div>
</div>
<div *ngIf="this.serviceEntry==true">
    <div class="userinfo full">
        <div class="basicrow">
            <div class="basicrow roboto-b m-bott text-center msj">
                {{this.ticketExists}}
            </div>
        </div>
    </div>
</div>
<div class="basicrow" *ngIf="(this.ticketExists=='Ingreso de datos inválido.'|| this.ticketOpened=='N') && this.serviceEntry==false">
    <div class="container">
        <div class=" notopbrd">
            <div class="basicrow allpads f-reg roboto-r f-black">
                <div class="basicrow m-top-i">
                    <div class="logline full"></div>
                </div>
                <div class="basicrow text-center m-top-u">
                    Por favor, especifique el tipo de aver&iacute;a que desea reportar, sea por su L&iacute;nea Fija
                    o su L&iacute;nea Fija + DSL.
                </div>
                <div class="basicrow text-center m-top">
                    <div class="caja-general">
                        <div class="caja-left text-center roboto-b">
                            <div class="autorow pointerdef">
                                <input name="radio_{{index}}" id="linea_dsl_{{index}}" type="radio" class="pointerdef">
                                <label class="cursor" for="linea_dsl_{{index}}" class="spaceOption">L&iacute;nea +
                                    DSL</label>
                            </div>
                        </div>
                        <div class="caja-right text-center roboto-b">
                            <div class="autorow pointerdef">
                                <input type="radio" name="radio_{{index}}" id="solo_linea_{{index}}" class="pointerdef">
                                <label class="cursor spaceOption" for="solo_linea_{{index}}" >Solo L&iacute;nea</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="basicrow m-top-i">
                    <div class="logline full"></div>
                </div>
                <div class="basicrow m-top">
                    <a (click)="this.continue1(this.index)" class="btns def-i red pull-right vcenter">
                        <span class="tabcell">
                            Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
